export default class ClubInvoiceAsset {
    static fromData(data) {
        if (!data) {
            return;
        }
        const clubInvoiceAsset = new ClubInvoiceAsset();

        clubInvoiceAsset.servicePeriod = {
            start: data.servicePeriod.data.start,
            end: data.servicePeriod.data.end,
        };
        clubInvoiceAsset.invoiceNumber = data.invoiceNumber;
        clubInvoiceAsset.consumer = data.consumer;
        clubInvoiceAsset.fee = data.fee;
        clubInvoiceAsset.category = data.category;
        clubInvoiceAsset.department = {
            id: data.department ? data.department.id : null,
            name: data.department ? data.department.name : null,
        };
        clubInvoiceAsset.factor = {
            numerator: data.factor.data.numerator,
            denominator: data.factor.data.denominator,
        };
        clubInvoiceAsset.unitPrice = {
            gross: {
                numerator: data.unitPrice.data.gross.data.numerator,
                denominator: data.unitPrice.data.gross.data.denominator,
            },
            net: {
                numerator: data.unitPrice.data.net.data.numerator,
                denominator: data.unitPrice.data.net.data.denominator,
            },
            vat: {
                numerator: data.unitPrice.data.vat.data.numerator,
                denominator: data.unitPrice.data.vat.data.denominator,
            },
            currency: data.unitPrice.data.currency,
        };
        clubInvoiceAsset.factorizedPrice = {
            gross: {
                numerator: data.factorizedPrice.data.gross.data.numerator,
                denominator: data.factorizedPrice.data.gross.data.denominator,
            },
            net: {
                numerator: data.factorizedPrice.data.net.data.numerator,
                denominator: data.factorizedPrice.data.net.data.denominator,
            },
            vat: {
                numerator: data.factorizedPrice.data.vat.data.numerator,
                denominator: data.factorizedPrice.data.vat.data.denominator,
            },
            currency: data.factorizedPrice.data.currency,
        };

        Object.seal(clubInvoiceAsset);

        return clubInvoiceAsset;
    }
}
